


















import { Swipe, SwipeItem } from "vant";
import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import request from "../api/index";
import Native from "../common/Native";
import { INewsItem } from "@/api/types.d.ts";
@Component({
  components: {
    Swipe,
    SwipeItem
  }
})
export default class Swiper extends Vue {
  /** 轮播图数据 */
  @Prop()
  private List!: Array<object>;
  itemClick(item: INewsItem) {
    Native.openWebBrowser({
      id: item.id + "",
      sourceId: item.informationId,
      detailViewType: item.detailViewType,
      sourceType: "1",
      contextType: "98",
      commentType: "0",
      isShowTop: "1",
      isShowBottom: "1",
      isShowMore: "0",
      url: item.url,
      shareUrl: item.shareUrl,
      title: item.title,
      synopsis: item.synopsis,
      shareImgUrl: item.shareImgUrl
    });
  }
}
